import HGetKeyFormEnum from "@helpers/HGetKeyFormEnum";
import { en as enLang, es as esLang } from "@lang";
import * as yup from "yup";

// Mapeamos los idiomas disponibles con sus traducciones específicas
const translations = {
  en: enLang.SubscriptionForm,
  es: esLang.SubscriptionForm,
};

export type Locale = keyof typeof translations;

/**
 * createSubscriptionFormSchema
 * Genera el esquema Yup para el formulario de suscripción tomando los textos
 * correspondientes al idioma indicado (‵es‵ por defecto).
 */
const createSubscriptionFormSchema = (locale: Locale = "es") => {
  const t: any = translations[locale];

  return yup.object({
    email: yup
      .string()
      .email(t.form.error.email.invalid)
      .required(t.form.error.email.required)
      .default(""),
    name: yup
      .string()
      .required(t.form.error.name.required)
      .default(""),
    interests: yup
      .array()
      .of(yup.string())
      .required(t.form.error.interests.required)
      .default([]),
    captcha: yup.string().required(t.form.error.captcha.required).default(""),
  });
};

// Exportamos el esquema en idioma ES por defecto para no romper la API actual
const subscriptionFormSchema = createSubscriptionFormSchema();

export default subscriptionFormSchema;
export { createSubscriptionFormSchema };

export type SubscriptionFormSchemaType = yup.InferType<ReturnType<typeof createSubscriptionFormSchema>>;

const SubscriptionFormDefaultValues: SubscriptionFormSchemaType = {
  email: "",
  name: "",
  interests: [],
  captcha: "",
};
const SubscriptionFormKeyEnum = HGetKeyFormEnum(
  SubscriptionFormDefaultValues
) as {
  [K in keyof typeof SubscriptionFormDefaultValues]: K;
};

export { SubscriptionFormDefaultValues, SubscriptionFormKeyEnum };
